import KeyValueItem from './KeyValueItem';
export type { KeyValueItemProps } from './KeyValueItem';

export default KeyValueItem;
